import React  from 'react'
import { useParams } from 'react-router-dom'
import styles from './StateHeader.module.scss'
import Content from '../../../components/Content'
import Layout from '../../../components/Layout'
import GeoProvider from '../../../components/GeoProvider'
import dataDisplayOptions from '../dataDisplayOptions'
import { startDate, endDate } from '../dates'
import Header from './Header'
import SystemNotification from '../../Dashboard/SystemNotification'
import ModelTabs from './ModelTabs'
import categoryDisplayOptions from '../categoryDisplayOptions'
const BirthTrendStateDashboard = () => {
 if(window.localStorage.getItem('bt_category')===null)
    {window.localStorage.setItem('bt_category',categoryDisplayOptions[0].value)}
  const { area, loc } = useParams()
  return (
    <Layout>
      <Content>
        <div className={styles.base}>
          <div className={styles.body}>
            <GeoProvider
              startDate={startDate}
              endDate={endDate}
              displayDate={"2025-01-01"}
              locationName={loc}
              mapOptions={dataDisplayOptions[0]['options'][0]}
              indicatorName={dataDisplayOptions[0]['options'][0].indicatorName}
              regionSelected={'fips'}
            >
              <SystemNotification/>
              <Header headerType={area} geo_id={loc} />
              <ModelTabs  geo_type={area}
                geo_parent={loc}
                zoomLocation={loc}>
              </ModelTabs>
            </GeoProvider>
          </div>
        </div>
      </Content>
    </Layout>
  )
}

export default BirthTrendStateDashboard
